"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = void 0;
const react_1 = require("react");
exports.UserContext = react_1.createContext(undefined);
//# sourceMappingURL=user-context.js.map